import styled from "styled-components";

export const CommentsWrapper = styled.section`
  ${props => props.styled}
`;

export const CommentsList = styled.div`
  position: relative;
`;
